// Design ExamEditor "Choices · select the correct answer": a radiogroup of
// letter choices (A-D) instead of a select. Shared by the manual-add form and
// the question edit dialog. Keyboard: roving tabindex, arrows move + select.
import { KeyboardEvent, useRef } from 'react';

const LETTERS = ['A', 'B', 'C', 'D'] as const;

export default function AnswerPicker({ value, onChange, label = 'Correct answer' }: {
  value: string; onChange: (letter: string) => void; label?: string;
}) {
  const refs = useRef<Array<HTMLButtonElement | null>>([]);
  const focusable = LETTERS.includes(value as typeof LETTERS[number]) ? value : LETTERS[0];
  const onKey = (e: KeyboardEvent, i: number) => {
    const step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
    if (!step) return;
    e.preventDefault();
    const next = (i + step + LETTERS.length) % LETTERS.length;
    onChange(LETTERS[next]);
    refs.current[next]?.focus();
  };
  return (
    <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
      {LETTERS.map((l, i) => {
        const on = value === l;
        return (
          <button key={l} type="button" role="radio" aria-checked={on} aria-label={`Choice ${l}`}
            ref={(el) => { refs.current[i] = el; }}
            tabIndex={l === focusable ? 0 : -1}
            onKeyDown={(e) => onKey(e, i)}
            onClick={() => onChange(l)}
            className={`inline-flex h-11 min-w-[56px] items-center justify-center gap-2 rounded-[12px] border px-4 font-mono text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent ${
              on
                ? 'border-navy bg-navy text-white dark:border-mist-fixed dark:bg-mist-fixed dark:text-navy'
                : 'border-line-strong bg-surface text-ink hover:border-slate'}`}>
            <span aria-hidden>{l}</span>
          </button>
        );
      })}
    </div>
  );
}
